import { Box, Modal, Stack, Typography } from "@mui/material";
import { Text } from "components/Text";
import useTranslate from "hooks/useTranslate";
import logo from "/images/SignLogo.svg";
import congrats from "/images/congrats.png";

interface EmailVerifiedSuccessDialogProps {
  open: boolean;
  onClose: () => void;
}

export default function EmailVerifiedSuccessDialog({
  open,
  onClose,
}: EmailVerifiedSuccessDialogProps) {
  const { translate } = useTranslate("admin.user");

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="email-verified-title"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
      }}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: "rgba(16, 24, 40, 0.35)",
            backdropFilter: "blur(2px)",
          },
        },
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 552,
          bgcolor: "#ffffff",
          borderRadius: "16px",
          boxShadow: "0 12px 40px rgba(16, 24, 40, 0.12)",
          px: { xs: 3, sm: 4 },
          py: { xs: 3.5, sm: 4 },
          textAlign: "center",
          outline: "none",
        }}
      >
        <Box
          component="img"
          src={logo}
          alt="tablies"
          sx={{
            width: 88,
            height: "auto",
            mx: "auto",
            display: "block",
            mb: 2.5,
          }}
        />

        <Box
          component="img"
          src={congrats}
          alt=""
          sx={{
            width: 120,
            height: 120,
            mx: "auto",
            display: "block",
            mb: 2.5,
            animation: "congratsBounce 1.8s ease-in-out infinite",
            "@keyframes congratsBounce": {
              "0%, 100%": { transform: "translateY(0) scale(1)" },
              "50%": { transform: "translateY(-10px) scale(1.05)" },
            },
          }}
        />

        <Stack spacing={1.5}>
          <Typography
            id="email-verified-title"
            sx={{
              color: "#020B12",
              fontSize: { xs: 22, sm: 24 },
              fontWeight: 700,
              lineHeight: 1.3,
            }}
          >
            {translate("congratulations")}
          </Typography>
          <Typography
            sx={{
              color: "#020B12",
              fontSize: { xs: 18, sm: 20 },
              fontWeight: 600,
              lineHeight: 1.4,
            }}
          >
            {translate("userVerifiedSuccefully")}
          </Typography>
          <Text
            variant="bodyLgRegular"
            sx={{
              color: "#7A8B98",
              lineHeight: 1.5,
              mt: 0.5,
            }}
          >
            {translate("letSignIn")}
          </Text>
        </Stack>
      </Box>
    </Modal>
  );
}
